

















import { Component, Prop, Vue } from "vue-property-decorator";

import { Const } from '@/const';
import { Template } from "@/data/template/template";
import { DebugHelper } from "@/helper/debugHelper";
import * as def from "@/definitions";

const isElement = (x: any): x is HTMLImageElement =>
  x instanceof HTMLImageElement;

@Component({
  components: {}
})
export default class TemplateView extends Vue {
    @Prop()
    private template!: Template;
    @Prop()
    private index!: number;
    @Prop()
    private selectedTemplate!: Template;

    // mounted(){
    //   DebugHelper.trace(this.template)
    // }

    selectTemplate() {
        this.$emit("selectTemplate", this.template.id);
    }

    decideTemplate() {
        this.selectTemplate();
        this.$emit("decideTemplate");
    }

    // private isSnsVisible(templateId){
    //     return (templateId ==  Const.TEMPLATE_ID_TWITTER || templateId == Const.TEMPLATE_ID_FACEBOOK) && !DebugHelper.isDebugMode;
    // }

  // get src(): string {
  //   return "http://label.entap.xyz/template_image/" + this.template.id + ".png";
  // }

  zeroPadding(num, length) {
    return ("0000000000" + num).slice(-length);
  }

    private get userConfigBorderColor(){
        var style = {
            border : "solid 4px " + this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
}
